import { TOrderStatusType, TUserPanelNavType, TTransactionStatusType } from '@features/userPanel/typescript';
import { getRegion } from '@utils/misc';

export const NAVIGATION_ITEM_MY_ACCOUNT = {
  name: 'myAccount',
  url: '#my-account',
};
export const NAVIGATION_ITEM_ADDRESS = { name: 'address', url: '#address' };
export const NAVIGATION_ITEM_BILLINGS = { name: 'billings', url: '#billings' };
export const NAVIGATION_ITEM_ORDERS = { name: 'orders', url: '#orders' };
export const NAVIGATION_ITEM_CREATIVE = { name: 'creative', url: '#creative' };

const billingNavigationAddresses: TUserPanelNavType =
  getRegion('uppercase') === 'EUR' ? [] : [NAVIGATION_ITEM_BILLINGS];

const creativeNavigationSection: TUserPanelNavType = getRegion('uppercase') === 'EUR' ? [] : [NAVIGATION_ITEM_CREATIVE];

export const NAVIGATION_ITEMS: TUserPanelNavType = [
  NAVIGATION_ITEM_MY_ACCOUNT,
  NAVIGATION_ITEM_ADDRESS,
  ...billingNavigationAddresses,
  NAVIGATION_ITEM_ORDERS,
  ...creativeNavigationSection,
];

export const TRANSACTION_STATUS_TO_ENABLE_REPAYMENT = [
  TTransactionStatusType.canceled,
  TTransactionStatusType.failed,
  TTransactionStatusType.rejected,
  TTransactionStatusType.initiation_cancelled,
  TTransactionStatusType.initiated,
];

export const TRANSACTION_STATUS_TO_BLOCK_REPAYMENT = [
  TTransactionStatusType.processing,
  TTransactionStatusType.refund_initiated,
  TTransactionStatusType.refunded,
  TTransactionStatusType.accepted,
  TTransactionStatusType.status_unknown,
];

export const ORDER_STATUS_TO_ENABLE_REPAYMENT = [
  TOrderStatusType.pending,
  TOrderStatusType.registered,
  TOrderStatusType.confirmed,
  TOrderStatusType.unconfirmed,
];

// NOTE: Statuses that we do not want to show in the order list
export const ORDER_LIST_FILTERS = {
  statusNot: [TOrderStatusType.draft],
};

export const delay = 10000;

export const CREATIVE_ID = '1122614';
